const toSecondes = 5
const dureeInfinie = -1

const state = {
  activation: false,
  couleur: 'success',
  duree: dureeInfinie,
  texte: ''
}

const getters = {
  // Acces via  this.$store.getters.activation
  activation(state) {
    return state.activation
  },
  couleur(state) {
    return state.couleur
  },
  duree(state) {
    return state.duree
  },
  texte(state) {
    return state.texte
  }
}

// Soit on passe une string avec le texte, soit une structure {texte: x, duree: y}
const actions = {
  afficherInfo({ commit }, input) {
    if (typeof input === 'object') {
      commit('mAfficher', {
        texte: input.texte,
        couleur: 'info',
        duree: input.duree
      })
    } else {
      commit('mAfficher', { texte: input, couleur: 'info', duree: toSecondes })
    }
  },
  afficherError({ commit }, input) {
    if (typeof input === 'object') {
      commit('mAfficher', {
        texte: input.texte,
        couleur: 'error',
        duree: input.duree
      })
    } else {
      // DF: Pas d'affichage de popup si token expire: pas genial...
      if (input.includes(': 401 ')) {
        console.log("afficherError: HTTP 401, pas d'affichage de popup")
        return
      }
      commit('mAfficher', {
        texte: input,
        couleur: 'error',
        duree: toSecondes
      })
    }
  },
  afficherSuccess({ commit }, input) {
    if (typeof input === 'object') {
      commit('mAfficher', {
        texte: input.texte,
        couleur: 'success',
        duree: input.duree
      })
    } else {
      commit('mAfficher', {
        texte: input,
        couleur: 'success',
        duree: toSecondes
      })
    }
  },
  afficherWarning({ commit }, input) {
    if (typeof input === 'object') {
      commit('mAfficher', {
        texte: input.texte,
        couleur: 'warning',
        duree: input.duree
      })
    } else {
      commit('mAfficher', {
        texte: input,
        couleur: 'warning',
        duree: toSecondes
      })
    }
  },
  effacer({ commit }) {
    commit('mEffacer')
  }
}

const mutations = {
  mAfficher(state, snack) {
    state.activation = new Date().getTime() // Faire changer la valeur a chaque fois
    state.couleur = snack.couleur
    state.duree =
      snack.duree == dureeInfinie ? dureeInfinie : 1000 * snack.duree // milliseconds
    state.texte = snack.texte
  },
  mEffacer(state) {
    state.activation = false
    state.couleur = ''
    state.duree = dureeInfinie
    state.texte = ''
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
